import React from "react";
import { Box } from "@mui/material";

/**
 * Shared brand wordmark for "BlazeAI".
 *
 * Light theme: "Blaze" in near-black (--ink-9), "AI" in amber.
 * Dark theme:  "Blaze" in off-white (--ink-9 flips), "AI" in amber.
 *
 * inGradient forces solid fills when the parent paints gradient text
 * (WebkitBackgroundClip: text), so the wordmark stays legible.
 */
export default function BlazeAIBrand({ inGradient = false }) {
  const solidOverride = inGradient
    ? {
        WebkitBackgroundClip: "initial",
        backgroundClip: "initial",
      }
    : null;

  return (
    <Box component="span" sx={{ textTransform: "none", letterSpacing: "normal", whiteSpace: "nowrap" }}>
      <Box
        component="span"
        sx={{
          color: "var(--ink-9)",
          fontWeight: "inherit",
          textTransform: "none",
          ...(solidOverride && {
            ...solidOverride,
            WebkitTextFillColor: "var(--ink-9)",
          }),
        }}
      >
        Blaze
      </Box>
      <Box
        component="span"
        sx={{
          color: "var(--amber)",
          fontWeight: "inherit",
          textTransform: "none",
          ...(solidOverride && {
            ...solidOverride,
            WebkitTextFillColor: "var(--amber)",
          }),
        }}
      >
        AI
      </Box>
    </Box>
  );
}
